import orderShippingMethodService from "@/services/orderShippingMethod";
export const shippingMethod = {
    namespaced: true,
    state: {
        list: []
    },
    getters: {
        shippingMethods: state => state.list.map(method => ({ value: method.id, label: method.name }))
    },
    mutations: {
        SET_LIST(state, data) {
            state.list = data;
        }
    },
    actions: {
        async populate({ commit, state }) {
            if (!state.list.length) {
                const list = await orderShippingMethodService.getAll();
                commit("SET_LIST", list);
                return list;
            }
        },
        clear({ commit }) {
            commit("SET_LIST", []);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/shippingMethod/index.js